import { render, staticRenderFns } from "./collaboratorDetail.vue?vue&type=template&id=75ed115b&scoped=true"
import script from "./collaboratorDetail.vue?vue&type=script&lang=js"
export * from "./collaboratorDetail.vue?vue&type=script&lang=js"
import style0 from "./collaboratorDetail.vue?vue&type=style&index=0&id=75ed115b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ed115b",
  null
  
)

export default component.exports